export const ICONS_CONTAINER_TEST_ID =
	'command-palette-common.controllers.transform-navigation-commands.icon-container';
export const NAVIGATION_LINK_TEST_ID =
	'command-palette-common.controllers.transform-navigation-commands.navigation-link';
